import { FC, PropsWithChildren, useEffect, useState } from 'react';
import i18next from 'i18next';

import { Language } from '@/shared/config';
import { LanguageContext } from '@/shared/contexts';
import { languageInstall } from '@/shared/libs';

export const LanguageProvider: FC<PropsWithChildren> = ({ children }) => {
  const [lang, setLang] = useState<Language>(languageInstall());

  const changeLang = (val: Language) => {
    i18next.changeLanguage(val);
    setLang(val);
  };

  useEffect(() => {
    if (i18next.language !== lang) {
      i18next.changeLanguage(lang);
    }
  }, []);

  return (
    <LanguageContext.Provider value={{ changeLang, lang }}>
      {children}
    </LanguageContext.Provider>
  );
};
